import ModalFilters from '@/language/es/components/filter/ModalFilters';

export default {
  ModalFilters,
};
